import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import axios from "axios";
import { Helmet } from "react-helmet-async";
import { IAllStates } from "../../../store/rootReducer";
import { IWorkflow } from "../../workflow/dto/IWorkflow";
import { WorkflowService } from "../../workflow/service";
import { handleStepNavigate } from "../../workflow/components/WorkflowStep2";
import { ErrorToast } from "../../../shared/toasters/toasters";
import { CategoryServicee } from "../../../store/category/categoryService";
import categorySlice from "../../../store/category/categoryRedux";
import { WorkflowList } from "../../workflow/components/WorkflowList";
import { ClientDashboardService } from "../service";
const initialPagination = {
  page: 1,
  perPage: 10,
  client: null,
  name: null,
  workflowStatus: undefined,
  fromDeadline: null,
  toDeadline: null,
};
export const WorkflowStep = () => {
  const navigate = useNavigate();
  const [createField, setCreateField] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [completeTab, setCompleteTab] = useState(false);
  const { workflowStatus } = useSelector((state: IAllStates) => state.enums);
  const [firstStap, setFirstStap] = useState<IWorkflow | undefined>();
  const [workflowList, setWorkflowList] = useState<IWorkflow[] | undefined>();
  const { accessRights } = useSelector((state: IAllStates) => state.auth);
  const [completedList, setCompletedList] = useState<IWorkflow[] | undefined>();
  const [currentWorkflow, setCurrentWorkflow] = useState<
    IWorkflow | undefined
  >();
  const currentUser = JSON.parse(localStorage.getItem("currentUser") as string);
  const isManager = currentUser?.roles?.includes("ROLE_MANAGER");
  const isAdmin = currentUser?.roles?.includes("ROLE_ADMIN");
  const isCompanyAdmin = currentUser?.roles?.includes("ROLE_COMPANY_ADMIN");
  const [pagination, setPagination] = useState(initialPagination);
  const [name, setName] = useState("");
  const [completeName, setCompleteName] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const handlePages = (updatePage: number) => {
    setPagination({ ...pagination, page: updatePage });
    setPage(updatePage);
  };
  const [paginationCompleted, setPaginationCompleted] = useState({
    page: 1,
    perPage: 10,
    client: null,
    name: null,
    workflowStatus: undefined,
    fromDeadline: null,
    toDeadline: null,
  });
  const [pageCompleted, setPageCompleted] = useState(1);
  const [totalPagesCompleted, setTotalPagesCompleted] = useState(0);

  const handlePagesCompleted = (updatePage: number) => {
    setPaginationCompleted({ ...paginationCompleted, page: updatePage });
    setPageCompleted(updatePage);
  };

  const [triggerUpdate, setTriggerUpdate] = useState(false);

  const handlePaginationStatus = (obj: any) => {
    if (!completeTab) {
      setPagination((prev) => ({
        ...prev,
        page: 1,
        workflowStatus: obj?.value,
      }));
    } else {
      setPaginationCompleted((prev) => ({
        ...prev,
        page: 1,
        workflowStatus: obj?.value,
      }));
    }
  };

  const handlePaginationClient = (obj: any) => {
    if (!completeTab) {
      setPagination(
        (prev) =>
          ({
            ...prev,
            page: 1,
            client: {
              id: obj?.value as number,
              name: obj?.label as string,
            },
          } as any)
      );
    } else {
      setPaginationCompleted(
        (prev) =>
          ({
            ...prev,
            page: 1,
            client: {
              id: obj?.value as number,
              name: obj?.label as string,
            },
          } as any)
      );
    }
  };

  const handlePaginationName = (e: any) => {
    const { value, name } = e.target;

    if (!completeTab) {
      setName((prev: any) => ({
        ...prev,
        value,
      }));
    } else {
      setCompleteName((prev: any) => ({
        ...prev,
        value,
      }));
    }
  };

  const handlePaginationFromDate = (e: any) => {
    if (!completeTab) {
      setPagination((prev) => ({
        ...prev,
        page: 1,
        fromDeadline: e,
      }));
    } else {
      setPaginationCompleted((prev) => ({
        ...prev,
        page: 1,
        fromDeadline: e,
      }));
    }
  };

  const handlePaginationToDate = (e: any) => {
    if (!completeTab) {
      setPagination((prev) => ({
        ...prev,
        page: 1,
        toDeadline: e,
      }));
    } else {
      setPaginationCompleted((prev) => ({
        ...prev,
        page: 1,
        toDeadline: e,
      }));
    }
  };

  const proceedHandler = (
    workflowId: number,
    status: string,
    tabs: any,
    e: any
  ) => {
    const linkStatus = tabs?.some((tab: string) => tab === status);
    if (e.type === "click") {
      handleStepNavigate(
        linkStatus === true ? status : tabs[0],
        Number(workflowId),
        navigate
      );
    } else {
      switch (status) {
        case "SETTING_UP":
          return window.open(`/app/workflow/step1/${workflowId}`, "_blank");
        case "IMPORT":
          return window.open(`/app/workflow/step2/${workflowId}`, "_blank");
        case "BASE_DATA":
          return window.open(`/app/workflow/step3/${workflowId}`, "_blank");
        case "ATTRIBUTES":
          return window.open(`/app/workflow/step4/${workflowId}`, "_blank");
        case "MEDIA":
          return window.open(
            `/app/workflow/step-media/${workflowId}`,
            "_blank"
          );
        case "COPY_WRITING":
          return window.open(`/app/workflow/step5/${workflowId}`, "_blank");
        case "TRANSLATION":
          return window.open(`/app/workflow/step6/${workflowId}`, "_blank");
        case "OVERVIEW":
          return window.open(`/app/workflow/step7/${workflowId}`, "_blank");
        case "EXPORT":
          return window.open(`/app/workflow/step8/${workflowId}`, "_blank");
        default:
          return window.open(`/app/workflow/step1/${workflowId}`, "_blank");
      }
    }
  };

  useEffect(() => {
    setName("");
    setCompleteName("");
  }, [completeTab]);
  useEffect(() => {
    if (completeTab) {
      ClientDashboardService.getAllWorkflows({
        ...paginationCompleted,
        client: (paginationCompleted as any)?.client?.id,
        workflowStatus: "COMPLETED",
        name: (completeName as any)?.value ?? "",
      })
        .then((response) => {
          setPagination(initialPagination);
          const { data } = response;
          setTotalPagesCompleted(
            Math.ceil(response?.count / response?.perPage)
          );
          setCompletedList(data);
          setPageCompleted(response?.page);
        })
        .catch((error) => ErrorToast(error));
    } else {
      ClientDashboardService.getAllWorkflows({
        ...pagination,
        client: (pagination as any)?.client?.id,
        name: (name as any)?.value ?? "",
      })
        .then((response) => {
          const { data } = response;
          if (pagination?.page > 1 && pagination?.page > response?.totalPages) {
            setPage(response?.totalPages);
            setPagination({ ...pagination, page: response?.totalPages });
          }
          !completeTab && setPaginationCompleted(initialPagination);
          setTotalPages(Math.ceil(response?.count / response?.perPage));
          setPage(response?.page);
          setWorkflowList(data);
        })
        .catch((error) => ErrorToast(error));
    }
  }, [
    pagination,
    paginationCompleted,
    triggerUpdate,
    createField,
    completeTab,
    name,
    completeName,
  ]);
  useEffect(() => {
    CategoryServicee.getAllCategories()
      .then((data) => {
        dispatch(categorySlice.actions.setCategory(data));
      })
      .catch((error) => ErrorToast(error));
  }, []);

  return (
    <>
      <WorkflowList
        completeTab={completeTab}
        setCompleteTab={setCompleteTab}
        isAdmin={isAdmin}
        isCompanyAdmin={isCompanyAdmin}
        isManager={isManager}
        accessRights={accessRights}
        list={workflowList as IWorkflow[] | undefined}
        //  changeFilterHandler={changeFilterHandler}
        proceedHandler={proceedHandler}
        setPagination={setPagination}
        page={page}
        totalPages={totalPages}
        setPaginationCompleted={setPaginationCompleted}
        pageCompleted={pageCompleted}
        totalPagesCompleted={totalPagesCompleted}
        handlePaginationStatus={handlePaginationStatus}
        handlePages={handlePages}
        handlePagesCompleted={handlePagesCompleted}
        setTriggerUpdate={setTriggerUpdate}
        havePagination={true}
        pagination={pagination}
        paginationCompleted={paginationCompleted}
        handlePaginationClient={handlePaginationClient}
        handlePaginationFromDate={handlePaginationFromDate}
        handlePaginationToDate={handlePaginationToDate}
        handlePaginationName={handlePaginationName}
        haveFilters={true}
        haveTabs={true}
        completedList={completedList}
        completeName={completeName}
        name={name}
      />
    </>
  );
};
